import { RingLoader } from "react-spinners";
import * as Styles from "./Spinner.styles";

export default function Spinner() {
  return (
    <Styles.SpinnerContainer>
      <RingLoader size={"5rem"} color="var(--color-primary)" />
    </Styles.SpinnerContainer>
  );
}
